<p>z-long works!</p>
<div style="height: 1000px;background-color: green;"><div></div></div>